var _a, _b;
import * as tslib_1 from "tslib";
import { handleActions } from 'redux-actions';
import pick from 'lodash/pick';
import { reduxKey } from './constants';
import { logPageView } from './actions';
var actionHandlers = handleActions((_a = {},
    _a[logPageView.toString()] = function (state, _a) {
        var payload = _a.payload;
        return tslib_1.__assign({}, state, { pageview: pick(payload, 'view', 'component', 'typeid', 'itemid') });
    },
    _a), { pageview: {} });
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducer.js.map